/* eslint-disable */
import cx from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Button, Form, FormGroup, FormControl, ControlLabel, Modal, InputGroup, Radio, InputGroupAddon } from 'react-bootstrap';
import moment from 'moment';
import { ss } from '../../utils/util';
import Dropzone from 'react-dropzone';
import Autosuggest from 'react-autosuggest';

import 'react-dates/initialize';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import {
  upload,
} from '../../actions';

import './OzFormComponent.css'


class OzModalButton extends Component {

  state = {};

  onShow() {
    if (this.props.wrapModal) {
      this.setState({ show: true });
    } else {
      this.props.onShow();
    }
  }

  onHide() {
    if (this.props.wrapModal) {
      this.setState({ show: false });
    } else {
      this.props.onHide();
    }
  }

  renderPopup() {
    let body = this.props.children[1];
    let footer = null;
    let show = this.props.show;

    if (this.props.wrapModal) {
      show = this.state.show;
      body = (
        <Modal.Body>
          {body}
        </Modal.Body>
      );

      footer = (
        <Modal.Footer>
          {this.props.cancelText && <Button onClick={() => this.onHide()}>{this.props.cancelText}</Button>}
          {this.props.buttonText && <span> <Button bsStyle={this.props.buttonStyle || 'primary'} onClick={() => this.props.onSubmit()}>{this.props.buttonText}</Button></span>}
        </Modal.Footer>
      );
    }

    return (
      <Modal backdrop="static" show={show} onHide={() => this.onHide()}>
        <Modal.Header closeButton>
          <Modal.Title>{this.props.modalTitle}</Modal.Title>
        </Modal.Header>
        {body}
        {footer}
      </Modal>
    );
  }

  render() {
    return (
      <span>
        <span onClick={() => this.onShow()}>{this.props.children[0]}</span>
        {this.renderPopup()}
      </span>
    );
  }
}

export default OzModalButton;



/** WEBPACK FOOTER **
 ** ./src/components/partials/OzModalButton.js
 **/